/**
 * EmailToolbar
 *
 * Action toolbar above the message list: archive, trash, mark read/unread,
 * star, move to folder, add label, snooze.
 */

import {
  Archive,
  Trash2,
  Mail,
  MailOpen,
  Star,
  FolderInput,
  Tag,
  Clock,
  RefreshCw,
} from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmailToolbarProps {
  selectedCount: number;
  schedulingEnabled?: boolean;
  onArchive: () => void;
  onTrash: () => void;
  onMarkRead: () => void;
  onMarkUnread: () => void;
  onStar: () => void;
  onSnooze?: () => void;
  onRefresh: () => void;
}

export function EmailToolbar({
  selectedCount,
  schedulingEnabled,
  onArchive,
  onTrash,
  onMarkRead,
  onMarkUnread,
  onStar,
  onSnooze,
  onRefresh,
}: EmailToolbarProps) {
  const hasSelection = selectedCount > 0;

  return (
    <div className="flex items-center gap-1 px-2 py-1 border-b border-border bg-background">
      {hasSelection ? (
        <>
          <Button variant="ghost" size="sm" onClick={onArchive} title="Archive (e)">
            <Archive className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="sm" onClick={onTrash} title="Trash (#)">
            <Trash2 className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="sm" onClick={onMarkRead} title="Mark read">
            <MailOpen className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="sm" onClick={onMarkUnread} title="Mark unread">
            <Mail className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="sm" onClick={onStar} title="Star (s)">
            <Star className="h-4 w-4" />
          </Button>
          <div className="w-px h-5 bg-border mx-1" />
          <Button variant="ghost" size="sm" disabled title="Move to folder">
            <FolderInput className="h-4 w-4" />
          </Button>
          <Button variant="ghost" size="sm" disabled title="Add label">
            <Tag className="h-4 w-4" />
          </Button>
          {schedulingEnabled && onSnooze && (
            <Button variant="ghost" size="sm" onClick={onSnooze} title="Snooze">
              <Clock className="h-4 w-4" />
            </Button>
          )}
        </>
      ) : (
        <Button variant="ghost" size="sm" onClick={onRefresh} title="Refresh">
          <RefreshCw className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
